export default {
  title: "Стенды",
  total: "Всего {amount}",

  allowedStands: "Разрешено к застройке",
  disallowedStands: "Не разрешено к застройке",

  lookBtn: "Просмотр стендов",

  pluralize: ["стенд", "стенда", "стендов"],

  modal: {
    allQuotas: "Всего квот:",
    allowedQuotas: "Доступно:",

    table: {
      standNumber: "Номер стенда",
      companyName: "Название компании",
      buildingPermission: "Разрешение на застройку",
      quotas: "Квота"
    },

    status: {
      allowed: "Разрешено",
      consideration: "На рассмотрении",
      notAllowed: "Не разрешено"
    }
  }
};
